import React, { memo, useCallback } from 'react';

import PropTypes from 'prop-types';
import { TextField } from '@picsio/ui';

import Tooltip from '../Tooltip/Tooltip';
import ReadOnlyFieldTooltip from './helpers/ReadOnlyFieldTooltip';
import { useLocalFieldValue } from './hooks';
import { productFieldInputProps } from './constants';
import styles from './styles.module.scss';

const ProductHandle = ({
  value, readOnly, readOnlyTooltip, onChange, isDiff,
}) => {
  const { localValue, setLocalValue } = useLocalFieldValue(value);

  const handleChange = useCallback((e) => {
    setLocalValue(e.target.value);
  }, [setLocalValue]);

  const handleBlur = useCallback(() => {
    const trimmed = localValue.trim();
    if (trimmed !== localValue) setLocalValue(trimmed);
    if (trimmed !== value) onChange?.(trimmed);
  }, [localValue, onChange, setLocalValue, value]);

  const handleKeyPress = useCallback((e) => {
    if (e.key === 'Enter') e.target.blur();
  }, []);

  return (
    <ReadOnlyFieldTooltip tooltip={readOnly ? readOnlyTooltip : null}>
      <div className={styles.row}>
        <TextField
          value={localValue}
          disabled={readOnly}
          label={(
            <Tooltip content={isDiff ? 'Unpublished changes' : null} placement="top">
              <span className={isDiff ? styles.diffDot : undefined}>Handle</span>
            </Tooltip>
          )}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyPress={handleKeyPress}
          inputProps={productFieldInputProps}
        />
      </div>
    </ReadOnlyFieldTooltip>
  );
};

ProductHandle.propTypes = {
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  readOnlyTooltip: PropTypes.string,
  isDiff: PropTypes.bool,
  onChange: PropTypes.func,
};

ProductHandle.defaultProps = {
  value: '',
  readOnly: false,
  readOnlyTooltip: null,
  isDiff: false,
  onChange: null,
};

export default memo(ProductHandle);
